import { isWeekend } from '../utils';
import Timeline from '@mui/lab/Timeline';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import LockIcon from '@mui/icons-material/Lock';
import TimelineDot from '@mui/lab/TimelineDot';
import Check from '@mui/icons-material/Check';
import Typography from '@mui/material/Typography';

const DoctorConfirmationIntro = () => {
  return (
    <>
      <div className="bp-font-primary-main bp-mb-4 bp-inline-flex bp-flex-col bp-items-start bp-justify-start bp-gap-3 bp-text-gray-100">
        Technology is great, but nothing beats a human. Let’s confirm your results with a real
        doctor. Here’s how it works:
      </div>
      <Timeline
        sx={{
          paddingX: 1,
          [`& .${timelineItemClasses.root}:before`]: {
            flex: 0,
            padding: 0,
          },
        }}
      >
        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot
              color="primary"
              sx={{
                m: 0,
              }}
            >
              <Check fontSize="small" />
            </TimelineDot>
            <TimelineConnector className="bp-w-1 bp-bg-blue-50" />
            <TimelineConnector className="bp-w-1 bp-bg-blue-50" />
          </TimelineSeparator>
          <TimelineContent sx={{ py: '18px', pl: 2, pt: 0.5, pr: 0 }}>
            <Typography variant="h6" component="span" className="bp-leading-[1.1]">
              Online assessment
            </Typography>
            <Typography variant="body2" className="bp-font-secondary-small bp-mt-1">
              You successfully finished your assessment.
            </Typography>
          </TimelineContent>
        </TimelineItem>
        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot
              color="primary"
              sx={{
                m: 0,
                color: 'white',
                position: 'relative',
                '&:after': {
                  content: '""',
                  width: '150%',
                  height: '150%',
                  backgroundColor: 'rgba(25, 108, 255, 0.40)',
                  position: 'absolute',
                  top: '-7px',
                  left: '-7px',
                  borderRadius: '100%',
                },
              }}
              className="after:bp-animate-pulse"
            >
              <LockOpenIcon fontSize="small" className="bp-z-10" />
            </TimelineDot>
            <TimelineConnector className="bp-w-1 bp-bg-blue-50" />
            <TimelineConnector className="bp-w-1" />
          </TimelineSeparator>
          <TimelineContent sx={{ py: '18px', pl: 2, pt: 0.5, pr: 0 }}>
            <Typography variant="h6" component="span" className="bp-leading-[1.1]">
              Today: Contact info & payment
            </Typography>
            <Typography variant="body2" className="bp-font-secondary-small bp-mt-1">
              We’ll send your visit transcript to a licensed doctor.
            </Typography>
          </TimelineContent>
        </TimelineItem>
        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot color="grey" sx={{ m: 0, color: 'white' }}>
              <LockIcon fontSize="small" />
            </TimelineDot>
          </TimelineSeparator>
          <TimelineContent sx={{ py: '18px', pl: 2, pt: 0.5, pr: 0 }}>
            <Typography variant="h6" component="span" className="bp-leading-[1.1]">
              {isWeekend() ? 'Monday' : 'Tomorrow'}: Get your results
            </Typography>
            <Typography variant="body2" className="bp-font-secondary-small bp-mt-1">
              You’ll receive your doctor-reviewed results via email within 24{' '}
              {isWeekend() ? 'business ' : ''}hours.
            </Typography>
          </TimelineContent>
        </TimelineItem>
      </Timeline>
    </>
  );
};

export default DoctorConfirmationIntro;
